import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import Select from "react-select";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { useNavigate } from "react-router-dom";

import { useAtom } from "jotai";
import { gbState, fYear } from "../../../components/shared/GlobalState";

import {
  incomeSourceOptions,
  paymentStatusOption,
} from "../../../components/Data/DropDownData";

import {
  FaArrowLeft,
  FaPlus,
  FaCalendarAlt,
  FaDollarSign,
  FaUser,
  FaListAlt,
} from "react-icons/fa";

const IncomeDuesUpdateChild = ({ selectedRecord }) => {
  dayjs.extend(utc);
  let navigate = useNavigate();
  const style = {
    control: (base) => ({
      ...base,
      border: "1px solid #e2e8f0",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#cbd5e0",
      },
    }),
  };

  const [{ errorLogApi, placeHolderText, Category, user }] = useAtom(gbState);
  const [financial_year] = useState({
    value: user?.current_financial_year,
    label: user?.current_financial_year,
  });
  const [churchMembers, setChurchMembers] = useState([]);
  const [categoryList, setCategoryList] = useState();

  const [useOtherNonMember, setUseOtherNonMember] = useState(false);

  // Fixed normalize function to handle UTC dates properly
  const normalizeDate = (date) => {
    if (!date) return null;

    try {
      console.log("Incoming date:", date);
      console.log("Date type:", typeof date);

      // If it's a string (most common case from database)
      if (typeof date === "string") {
        const parsed = dayjs.utc(date);
        console.log(
          "Parsed string as UTC:",
          parsed.format(),
          "Valid:",
          parsed.isValid()
        );
        return parsed.isValid() ? parsed : null;
      }

      // If it's a serialized dayjs object (from navigation state)
      // It has $isDayjsObject property but lost its methods
      if (
        date &&
        typeof date === "object" &&
        date.$isDayjsObject === true &&
        date.$d
      ) {
        // Extract the date string from the $d property
        const parsed = dayjs.utc(date.$d);
        console.log("Parsed serialized dayjs from $d:", parsed.format());
        return parsed.isValid() ? parsed : null;
      }

      // If it's a native Date object
      if (date instanceof Date) {
        const utcDate = dayjs.utc(date.toISOString());
        console.log("Converted Date to UTC:", utcDate.format());
        return utcDate.isValid() ? utcDate : null;
      }

      // If it's a valid dayjs object with methods
      if (
        date &&
        typeof date === "object" &&
        date.$isDayjsObject === true &&
        typeof date.toISOString === "function"
      ) {
        const utcDate = dayjs.utc(date.toISOString());
        console.log("Converted dayjs to UTC:", utcDate.format());
        return utcDate.isValid() ? utcDate : null;
      }

      // Fallback: try parsing as UTC (works for most formats)
      const parsed = dayjs.utc(date);
      console.log(
        "Fallback UTC parse:",
        parsed.format(),
        "Valid:",
        parsed.isValid()
      );
      return parsed.isValid() ? parsed : null;
    } catch (error) {
      console.error("Error normalizing date:", error);
      return null;
    }
  };

  // Log the selectedRecord to see what we're getting
  console.log("=== selectedRecord ===", selectedRecord);
  console.log("start_date value:", selectedRecord?.start_date);

  const [formData, setFormData] = useState({
    category_id: selectedRecord?.category_id?._id,
    dues_title: selectedRecord?.dues_title,
    description: selectedRecord?.description,
    member_id: selectedRecord?.member_id?._id,
    start_date: normalizeDate(selectedRecord?.start_date),
    pledged_amount: selectedRecord?.pledged_amount,
    preferred_payment_mode: selectedRecord?.preferred_payment_mode,
    status: selectedRecord?.status,
    financial_year: financial_year?.value,
  });

  console.log("=== formData.start_date ===", formData.start_date);
  console.log("Is dayjs?", formData.start_date?.$isDayjsObject);
  console.log("Formatted:", formData.start_date?.format?.());

  //Load categories
  useEffect(() => {
    const getDataFromServer = () => {
      let userToken = localStorage.getItem("token");

      let urlLink = `${process.env.REACT_APP_API_URL}/category/income/${user?.church_id}`;

      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      axios(config)
        .then((response) => {
          const oldData = response.data.Categorys;
          const updatedData = oldData.map((data) => ({
            value: data?._id,
            label: data?.category_name,
          }));
          setCategoryList(updatedData);
        })
        .catch((err) => {
          console.log("error api call ", err.response.data.message);
        });
    };
    getDataFromServer();
  }, []);

  //Load members
  useEffect(() => {
    let userToken = localStorage.getItem("token");
    const config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/user/church/${user?.church_id}`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios(config)
      .then((response) => {
        const members = response?.data?.users;
        setChurchMembers(
          members.map((member) => ({
            value: member._id,
            label: member.first_name + " " + member.last_name,
          }))
        );
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error);
        errorLogApi(error, "ChurchMemberList", "/income");
      });
  }, []);

  const handleChange = ({ currentTarget: input }) => {
    setFormData({
      ...formData,
      [input.name]: input.value,
    });
  };

  const handleUpdateIncome = (e) => {
    e.preventDefault();

    if (!formData?.pledged_amount) return toast.error("Please enter amount");

    let userToken = localStorage.getItem("token");

    // Prepare data with proper UTC date formatting
    const dataToSend = {
      ...formData,
      financial_year: financial_year?.label,
      // Convert the date to ISO string if it's a dayjs object
      start_date: formData.start_date
        ? formData.start_date.$isDayjsObject
          ? formData.start_date.toISOString()
          : formData.start_date
        : null,
    };

    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/incomedues/update/${selectedRecord?._id}`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: dataToSend,
    };

    axios(config)
      .then((response) => {
        toast.success("Dues Updated Successfully.");
        navigate("/dues-income");
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
        errorLogApi(error, "IncomeduesUpdateChild", "/incomedues/update");
      });
  };

  return (
    <div className="flex justify-center p-8 w-full min-h-screen bg-gray-100">
      <div className="p-8 w-full max-w-2xl bg-white rounded-lg shadow-lg">
        <form autoComplete="off" className="space-y-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-800">
              Update Dues Income
            </h2>
            <div className="flex space-x-2">
              <button
                type="button"
                className="flex items-center px-4 py-2 text-white bg-gray-600 rounded-md transition duration-300 hover:bg-gray-700"
                onClick={() => navigate(-1)}
              >
                <FaArrowLeft className="mr-2" /> Back
              </button>
              <button
                className="flex items-center px-4 py-2 text-white bg-blue-600 rounded-md transition duration-300 hover:bg-blue-700"
                onClick={(e) => handleUpdateIncome(e)}
              >
                <FaPlus className="mr-2" /> Update
              </button>
            </div>
          </div>

          <div className="space-y-4">
            <Select
              name="category_id"
              onChange={(selected) => {
                setFormData({
                  ...formData,
                  category_id: selected.value,
                });
              }}
              options={categoryList}
              placeholder={
                <div className="flex items-center">
                  <FaListAlt className="mr-2" />{" "}
                  {placeHolderText("Select Category")}
                </div>
              }
              className="w-full"
              styles={style}
              value={
                formData?.category_id &&
                categoryList?.find((c) => c.value === formData?.category_id)
              }
            />

            <input
              className="p-3 w-full rounded-md border border-gray-300 transition duration-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              name="dues_title"
              type="text"
              required
              placeholder="Dues Title"
              autoComplete="off"
              onChange={handleChange}
              value={formData?.dues_title}
            />

            <div className="relative">
              <DatePicker
                className="p-3 w-full rounded-md border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                name="start_date"
                onChange={(date) => {
                  // Store as dayjs UTC object
                  if (date) {
                    const utcDate = dayjs.utc(date.format("YYYY-MM-DD"));
                    setFormData({
                      ...formData,
                      start_date: utcDate,
                    });
                  } else {
                    setFormData({
                      ...formData,
                      start_date: null,
                    });
                  }
                }}
                showToday
                value={formData?.start_date}
                format="MM-DD-YYYY"
              />
              <FaCalendarAlt className="absolute right-3 top-1/2 w-5 h-5 text-gray-400 transform -translate-y-1/2 pointer-events-none" />
            </div>

            <Select
              name="member_id"
              onChange={(selected) => {
                setFormData({
                  ...formData,
                  member_id: selected?.value,
                  other_non_member: null,
                });
              }}
              options={churchMembers}
              placeholder={
                <div className="flex items-center">
                  <FaUser className="mr-2" /> {placeHolderText("Select Member")}
                </div>
              }
              className="w-full"
              styles={style}
              isClearable
              value={
                formData?.member_id &&
                churchMembers?.find((m) => m.value === formData?.member_id)
              }
            />

            <div className="relative">
              <FaDollarSign className="absolute top-3 left-3 text-gray-400" />
              <input
                className="p-3 pl-10 w-full rounded-md border border-gray-300 transition duration-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                name="pledged_amount"
                type="number"
                required
                placeholder="Enter Amount"
                autoComplete="off"
                onChange={handleChange}
                value={formData?.pledged_amount}
              />
            </div>

            <Select
              name="status"
              onChange={(selected) => {
                setFormData({
                  ...formData,
                  status: selected.value,
                });
              }}
              options={paymentStatusOption}
              placeholder={placeHolderText("Select Status")}
              className="w-full"
              styles={style}
              value={
                formData?.status &&
                paymentStatusOption.find((p) => p.value === +formData?.status)
              }
            />

            <Select
              name="preferred_payment_mode"
              onChange={(selected) => {
                setFormData({
                  ...formData,
                  preferred_payment_mode: selected.value,
                });
              }}
              options={incomeSourceOptions}
              placeholder={placeHolderText("Preferred Mode")}
              className="w-full"
              styles={style}
              value={
                formData?.preferred_payment_mode &&
                incomeSourceOptions?.find(
                  (s) => s.value === +formData?.preferred_payment_mode
                )
              }
            />

            <textarea
              className="p-3 w-full rounded-md border border-gray-300 transition duration-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              name="description"
              rows={3}
              placeholder="Description"
              autoComplete="off"
              onChange={handleChange}
              value={formData?.description}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default IncomeDuesUpdateChild;
